import { GRADE } from './GradesConstants';
import { TITLE } from './CommonConstants';
import { TITLE as SHARED_PM_TITLE } from './PMConstants';
import { DATE_PICKER, FORM, RESPONSE } from './WebEntryConstants';

const {
    SECOND_GRADE,
    THIRD_GRADE,
    FIFTH_GRADE,
    FOURTH_GRADE,
    SEVENTH_GRADE,
    SIXTH_GRADE,
    EIGHTH_GRADE,
    NINTH_GRADE,
    TENTH_GRADE,
    ELEVENTH_GRADE,
    TWELFTH_GRADE,
} = GRADE;

export const BASIC_COMPREHENSION_MAX_SCORES_MAP_FOR_GRADES = {
    [SECOND_GRADE]: 49,
    [THIRD_GRADE]: 52,
    [FOURTH_GRADE]: 58,
    [FIFTH_GRADE]: 64,
    [SIXTH_GRADE]: 71,
    [SEVENTH_GRADE]: 71,
    [EIGHTH_GRADE]: 71,
    [NINTH_GRADE]: 71,
    [TENTH_GRADE]: 71,
    [ELEVENTH_GRADE]: 71,
    [TWELFTH_GRADE]: 71,
};

export const PANEL_TYPES_MAP = {
    [SHARED_PM_TITLE.PM_TITLE]: [
        DATE_PICKER,
        FORM.FORM_GRADE,
        FORM.FORM_NUMBER,
        RESPONSE.CORRECT_RESPONSES,
        RESPONSE.INCORRECT_RESPONSES,
    ],
    [TITLE.BENCHMARK_TITLE]: [
        DATE_PICKER,
        RESPONSE.CORRECT_RESPONSES,
        RESPONSE.INCORRECT_RESPONSES,
    ],
};
